// src/services/api.js
// Use uma URL relativa para que a requisição seja feita ao mesmo domínio
 const BASE_URL = "https://vale-back.onrender.com";
//const BASE_URL = "http://localhost:3001";

const getAuthHeaders = () => {
  const token = localStorage.getItem("admin-token");
  return token ? { "Authorization": `Bearer ${token}` } : {};
};

export const getProducts = async () => {
  const response = await fetch(`${BASE_URL}/products`);
  if (!response.ok) {
    throw new Error("Failed to fetch products");
  }
  return response.json();
};

export const getProductById = async (id) => {
  const response = await fetch(`${BASE_URL}/products/${id}`);
  if (!response.ok) {
    throw new Error("Failed to fetch product");
  }
  return response.json();
};

export const getProductVariants = async (productId) => {
  const response = await fetch(`${BASE_URL}/products/${productId}/variants`);
  if (!response.ok) {
    throw new Error("Failed to fetch product variants");
  }
  return response.json();
};

export const createProduct = async (data) => {
  const response = await fetch(`${BASE_URL}/products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders()
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Failed to create product");
  }
  return response.json();
};

export const updateProduct = async (id, data) => {
  const response = await fetch(`${BASE_URL}/products/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders()
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Failed to update product");
  }
  return response.json();
};

export const updateProductVariant = async (productId, variantId, data) => {
  const response = await fetch(`${BASE_URL}/products/${productId}/variants/${variantId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders()
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Failed to update product variant");
  }
  return response.json();
};

export const deleteProduct = async (id) => {
  const response = await fetch(`${BASE_URL}/products/${id}`, {
    method: "DELETE",
    headers: {
      ...getAuthHeaders()
    },
  });
  if (!response.ok) {
    throw new Error("Failed to delete product");
  }
  return response.json();
};

export const adminLogin = async (username, password) => {
  const response = await fetch(`${BASE_URL}/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!response.ok) {
    throw new Error("Failed to login");
  }
  return response.json();
};
